import { createFileRoute } from '@tanstack/react-router';

import { FileManagerTable } from 'component/partial/tables/file-manager/FileManagerTable';

import { requireOperation } from './-guards';
import { siteTabOperations } from './-site-tabs';

export const Route = createFileRoute('/n/_auth/sites/$siteId/_details/file-manager')({
  beforeLoad: requireOperation({
    options: ({ params }) => siteTabOperations.fileManager(params.siteId),
    siteId: ({ params }) => params.siteId,
  }),
  component: FileManagerRoute,
});

function FileManagerRoute() {
  return <FileManagerTable />;
}
